<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M461.7 481.4c0 13.1-8.7 23.6-19.5 23.7l-372.4.4c-10.8 0-19.5-10.6-19.5-23.6l-.4-451.8c0-13.1 8.7-23.6 19.5-23.7l274-.3 118 110.7.3 364.6z" fill="#c9cdd4" />
      <path fill="none" d="M50 6h412v500H50z" />
      <path d="m461.7 119.7-99.4.1c-10.8 0-19.5-10.6-19.5-23.6L342.7 9l119 110.7zM235.2 434.4v-41.5h41.5v41.5h-41.5zm2.1-66.1-.1-1.9c-.1-4.4-.2-7.7-.2-9.9 0-13.1 1.9-24.6 5.6-34.2 2.7-7.2 7.2-14.6 13.3-22 4.5-5.3 12.5-13.1 23.9-23.2 11.2-9.9 18.5-17.8 21.8-23.6 3.2-5.6 4.9-11.9 4.9-18.6 0-12.2-4.8-23.1-14.4-32.3-9.6-9.3-21.5-14-35.4-14-13.4 0-24.8 4.3-33.8 12.6-9 8.4-15 21.9-17.9 40l-.3 1.9-37.8-4.5.2-2c3.1-25.4 12.5-45.2 27.8-58.7 15.4-13.6 35.9-20.5 61.1-20.5 26.6 0 48.2 7.4 64.1 21.9 16 14.6 24.1 32.5 24.1 53.3 0 12-2.9 23.2-8.5 33.4-5.6 10-16.6 22.4-32.6 36.6-10.6 9.4-17.6 16.4-20.8 20.7-3.1 4.3-5.5 9.3-7 14.9-1.5 5.7-2.4 15.1-2.7 28.1v2h-35.3z" fill="#86909c" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
